'use strict';

import React from 'react';
import AnalyticsManager from 'services/analyticsManager';
import Formsy from 'formsy-react';
import 'services/formsyValidation';

import LeaveApplyEntitlements from 'components/profile/sections/LeaveApplyEntitlements';
import LeaveApplyOverlappedLeave from 'components/profile/sections/LeaveApplyOverlappedLeave';
import LeaveApplyAttachments from 'components/profile/sections/LeaveApplyAttachments';

import ModalHeader from 'components/base/ModalHeader';
import ModalBody from 'components/base/ModalBody';
import ModalFooter from 'components/base/ModalFooter';

import modalActions from 'actions/ModalActionCreators';
import personStore from 'stores/PersonStore';
import personActions from 'actions/PersonActionCreators';

import Fieldset from 'components/base/form-components/FieldSet';
import Group from 'components/base/form-components/Group';
import TextInputWithSign from 'components/base/form-components/TextInputWithSign';
import TextArea from 'components/base/form-components/TextArea';
import Select from 'components/base/form-components/Select';
import DateInput from 'components/base/form-components/DateInput';
import ConfirmationModalContent from 'components/base/ConfirmationModalContent';

import ConditionalDisplay from 'components/utils/ConditionalDisplay';

import StatusBar from  'components/base/StatusBar';
import CheckBox from 'components/base/form-components/CheckBox';

import constants from 'constants/appConstants';
import utils from 'services/utils';
import _ from 'underscore';
import moment from 'moment';
import Popover from 'components/base/Popover';
import PopoverContent from 'components/base/PopoverContent';
import PopoverContentSection from 'components/base/PopoverContentSection';
import PopoverIcon from 'components/base/PopoverIcon';

import TimeInput from '../../base/form-components/TimeInput';

import 'styles/LeaveApply.scss';
import 'styles/LeaveBalance.scss';


class LeaveApply extends React.Component {

    constructor(props) {
        super(props);
        const workdays = (this.props.application && this.props.application.WorkingDays) ? this.props.application.WorkingDays : undefined;
        const workhours = (this.props.application && this.props.application.TotalHours) ? this.props.application.TotalHours : undefined;
        const leaveEnterHoursOrDays = this.props.configOptionsManager.getOption("leaveEntry", this.props.person.ApiKey);
        const showHalfDaySessions = this.props.configOptionsManager.getOption("leave.showHalfDaySessions", this.props.person.ApiKey);   
        
        const today = moment();
        var startDate = moment({year: today.year(), month: today.month(), day: today.date()});
        var endDate = moment({year: today.year(), month: today.month(), day: today.date()});
        if (this.props.application) {
            startDate = moment(this.props.application.StartDate);
            endDate = moment(this.props.application.EndDate);
        }

        this.state = {
            isEditMode: this.props.hasOwnProperty('application'),
            startDate,
            endDate,
            canContinue: true,
            selectedLeaveReason: this.props.application ? this.props.application.LeaveReason : null,
            previousLeaveHours: (this.props.application && this.props.application.TotalHours) ? this.props.application.TotalHours : 0,
            workDaysAndHours: {
                DaysHours: {
                    Days: workdays,
                    Hours: workhours,
                },
            },
            tempHoursPerDay: (workdays && workhours) ? workhours / workdays : null,
            attachmentInfos: this.props.application ? this.props.application.AttachmentInfos : null,
            autoCalculateBalances: true,
            needToRecalculateBalance: false,
            leaveEnterHoursOrDays,
            showHalfDaySessions,
            isHalfDay: this.isHalfDayApplication(this.props.application),
            startSession: this.getInitStartSession(this.props.application),
            endSession: this.getInitEndSession(this.props.application),
            hasOverlappedLeave: false,
            IsHourApplication: this.props.application ? this.props.application.IsHourApplication : false,
            startTime: this.props.application ? moment(this.props.application.StartTime, 'H:mm').format('H:mm') : null,
            endTime: this.props.application ? moment(this.props.application.EndTime, 'H:mm').format('H:mm') : null,
        };        
        this.onPersonChange = this.onPersonChange.bind(this);
        this.onDaysHoursChange = this.onDaysHoursChange.bind(this);
        this.onEntitlementsChange = this.onEntitlementsChange.bind(this);
        this.shouldEnableButton = this.shouldEnableButton.bind(this);
        this.submitValid = this.submitValid.bind(this);
        this.getAppData = this.getAppData.bind(this);
        this.convertDate = this.convertDate.bind(this);
        this.calculateLeaveDaysHours = this.calculateLeaveDaysHours.bind(this);
        this.getWorkDaysHours = this.getWorkDaysHours.bind(this);
        this.isInsufficientBalance = this.isInsufficientBalance.bind(this);
        this.getLeaveEntitlements = this.getLeaveEntitlements.bind(this);
        this.checkDates = this.checkDates.bind(this);
        this.handleLeaveReasonSelect = this.handleLeaveReasonSelect.bind(this);
        this.onUpdateLeaveAppChange = this.onUpdateLeaveAppChange.bind(this);
        this.updateAttachment = this.updateAttachment.bind(this);
        this.onCalculateBalanceClick = this.onCalculateBalanceClick.bind(this);
        this.refreshWorkDayHours = this.refreshWorkDayHours.bind(this);
        this.handleApplyHalfDayCheckBoxChange = this.handleApplyHalfDayCheckBoxChange.bind(this);
        this.handleStartSessionSelect = this.handleStartSessionSelect.bind(this);
        this.handleEndSessionSelect = this.handleEndSessionSelect.bind(this);
        this.onOverlappedLeaveChange = this.onOverlappedLeaveChange.bind(this);
        this.handleApplyHourCheckBoxChange = this.handleApplyHourCheckBoxChange.bind(this);
        this.onLeaveTimesChange = this.onLeaveTimesChange.bind(this);
    }

    componentDidMount() {
        personStore.addChangeListener(this.onPersonChange);
        personStore.addSinglePersonWorkDaysAndHoursChangeListener(this.onDaysHoursChange);
        personStore.addSinglePersonLeaveEntitlementsChangeListener(this.onEntitlementsChange);
        personStore.addUpdateLeaveAppChangeListener(this.onUpdateLeaveAppChange);
        
        if (!this.props.application) {
            this.setState({
                workDaysAndHours: {
                    DaysHours: {
                        Days: null,
                        Hours: null,
                    },
                    loading: true,
                },
            });
        } else {
            const selectedLeaveReason = this.props.application.LeaveReason;

            if (selectedLeaveReason.LeaveType.Name !== 'OtherLeave' && selectedLeaveReason.LeaveType.IsDisplayBalance) {
                this.getLeaveEntitlements(this.props.application.LeaveReason, true);
            }
        }

        personActions.getSinglePersonLeave(this.props.person.Id, {
            Name: 'All',
            PageNumber: 1,
            RecordsPerPage: 20,
            LeaveStatusList: [
                constants.ENUMS.LEAVE_STATUS.PENDING,
                constants.ENUMS.LEAVE_STATUS.APPROVED,
                constants.ENUMS.LEAVE_STATUS.IN_APPROVAL,
                constants.ENUMS.LEAVE_STATUS.CANCELLED,
                constants.ENUMS.LEAVE_STATUS.DECLINED,
            ],
            SortingType: 0,
            IsSortingDesc: true,
        });

        if (!this.props.person.leaveReasons) {
            personActions.getSinglePersonLeaveReasons(this.props.person.Id);
        } else {
            var leaveReasonMap = {};
            _.each(this.props.person.leaveReasons, function (reason) {
                leaveReasonMap[reason.Id] = reason;
            });

            this.setState({
                leaveReasonMap,
                leaveReasons: this.props.person.leaveReasons,
            });
        }

    }

    componentWillUnmount() {
        personStore.removeChangeListener(this.onPersonChange);
        personStore.removeSinglePersonWorkDaysAndHoursChangeListener(this.onDaysHoursChange);
        personStore.removeSinglePersonLeaveEntitlementsChangeListener(this.onEntitlementsChange);
        personStore.removeUpdateLeaveAppChangeListener(this.onUpdateLeaveAppChange);
        personStore.resetWorkDaysHours();
    }
    
    isHalfDayApplication(application) {
        if (!application)
            return false; 
        else if (application.StartSession === null && application.WorkingDays !== Math.floor(application.WorkingDays))
            return true;
        else if (application.StartSession === constants.ENUMS.LEAVE_HALFDAY_SESSIONS.SECOND_HALF.VALUE || 
                    application.EndSession === constants.ENUMS.LEAVE_HALFDAY_SESSIONS.FIRST_HALF.VALUE)
            return true;
        else
            return false;
    }

    getInitStartSession(application) {
        if (!application)
            return constants.ENUMS.LEAVE_HALFDAY_SESSIONS.FIRST_HALF.VALUE;
        else if (application.StartSession !== null)
            return application.StartSession;
        else if (this.isHalfDayApplication(application))
            return null;
        else
            return constants.ENUMS.LEAVE_HALFDAY_SESSIONS.FIRST_HALF.VALUE;
    }

    getInitEndSession(application) {
        if (!application)
            return constants.ENUMS.LEAVE_HALFDAY_SESSIONS.SECOND_HALF.VALUE;
        else if (application.EndSession !== null)
            return application.EndSession;
        else if (this.isHalfDayApplication(application))
            return null;
        else
            return constants.ENUMS.LEAVE_HALFDAY_SESSIONS.SECOND_HALF.VALUE;
    }

    onPersonChange() {
        var _state = personStore.getPerson();
        var leaveReasonMap = {};
        _.each(_state.person.leaveReasons, function (reason) {
            leaveReasonMap[reason.Id] = reason;
        });

        this.setState({
            leaveReasonMap,
            leaveReasons: _state.person.leaveReasons,
        });

        if (!this.state.leaveApplications && _state.person.leaveApplications && _state.person.leaveApplications.All && _state.person.leaveApplications.All.applications) {
            setTimeout(function () {
                this.setState({
                    leaveApplications: _state.person.leaveApplications.All.applications,
                }, function () {
                    if (!this.props.application) {
                        const today = moment();
                        this.getWorkDaysHours(
                            moment({year: today.year(), month: today.month(), day: today.date()}),
                            moment({year: today.year(), month: today.month(), day: today.date()}),
                            constants.ENUMS.LEAVE_HALFDAY_SESSIONS.FIRST_HALF.VALUE,
                            constants.ENUMS.LEAVE_HALFDAY_SESSIONS.SECOND_HALF.VALUE
                        );
                    }
                });
            }.bind(this), 0);
        }
    }
    
    onDaysHoursChange() {    
        var _state = personStore.getPerson();
        
        if (_.isEqual(_state.person.workDaysAndHours.searchParams, this.state.lastSearchParams)) {
            this.setState({
                forecastingError: _state.person.workDaysAndHours.error,
                workDaysAndHours: _state.person.workDaysAndHours,
                isInsufficientBalance: this.state.leaveEnterHoursOrDays === 'days' 
                    ? this.isInsufficientBalance(this.refs.leaveDays.getValue()) 
                    : this.isInsufficientBalance(this.refs.leaveHours.getValue()),
                tempHoursPerDay: (_state.person.workDaysAndHours.DaysHours && _state.person.workDaysAndHours.DaysHours.Days > 0)
                    ? _state.person.workDaysAndHours.DaysHours.Hours / _state.person.workDaysAndHours.DaysHours.Days 
                    : (this.props.person.leaveBalances && this.props.person.leaveBalances.balances && this.props.person.leaveBalances.balances.length > 0 
                        ? this.props.person.leaveBalances.balances[0].HoursPerDay : null),
            });
        } else {
            const workDaysandHoursClone = _.extend({}, this.state.workDaysAndHours);
            workDaysandHoursClone.loading = true;

            this.setState({
                workDaysAndHours: workDaysandHoursClone,
            });
        }        
    }

    onEntitlementsChange() {
        var _state = personStore.getPerson();

        this.setState({
            forecastingError: _state.person.leaveBalanceValidation.error,
            leaveEntitlements: _state.person.leaveBalanceValidation,
            isInsufficientBalance: this.state.leaveEnterHoursOrDays === 'days' 
                ? this.isInsufficientBalance(this.refs.leaveDays.getValue())
                : this.isInsufficientBalance(this.refs.leaveHours.getValue()),
            autoCalculateBalances: false,
        });

        setTimeout(() => {
            modalActions.refreshModal();
        }, 0);
    }

    onUpdateLeaveAppChange() {
        const _state = personStore.getPerson();

        const leaveApplication =  _state.person.leaveApplication;
        let error = false;

        let message = "";
        let heading = "Applying for Leave";

        if (!leaveApplication.loading) {

            if (leaveApplication.error) {
                error = true;
                heading = "Oops!";
                message = (
                    <StatusBar
                        content={leaveApplication.error}
                        error
                    />
                );

            } else if (leaveApplication.status === constants.ENUMS.LEAVE_STATUS.APPROVED) {
                heading = "Success!";
                message = "Your leave application has been successfully submitted and approved.";

            } else if (leaveApplication.status === constants.ENUMS.LEAVE_STATUS.PENDING) {
                heading = "Success Pending Approval";
                message = (
                    <StatusBar
                        content="Your leave application has been successfully submitted and is now pending approval."
                        warning
                    />
                );
            } else if (!leaveApplication.loading) {
                heading = "Successfully Updated";
                message = "Your leave application has been successfully updated.";

            }

            if (!error && this.props.onAppliedCallback) {
                this.props.onAppliedCallback();
            }

            setTimeout(function () {
                modalActions.showModal(
                    <ConfirmationModalContent
                        header={heading}
                        message={message}
                    />
                );
            }, 0);
        }

        setTimeout(function () {
            modalActions.loading(leaveApplication.loading);
        }, 0);
    }

    shouldEnableButton(leaveDaysValue) {

        return this.state.leaveReasons &&
            this.state.leaveReasons.length > 0 &&
            this.state.selectedLeaveReason !== null &&
            (this.state.canContinue || !this.state.isInsufficientBalance) &&
            (this.state.workDaysAndHours ? !this.state.workDaysAndHours.loading : true) &&
            (this.state.workDaysAndHours.DaysHours ? !(this.state.IsHourApplication) && (this.state.workDaysAndHours.DaysHours.Days > 0 || this.state.workDaysAndHours.DaysHours.Hours > 0) : true) ||
            (this.state.IsHourApplication && this.state.startTime !== null && this.state.endTime !== null && leaveDaysValue <= 1) &&
            (this.state.showHalfDaySessions && this.state.isHalfDay ? this.state.startSession !== null && this.state.endSession !== null : true) &&
            (this.state.showHalfDaySessions ? !this.state.hasOverlappedLeave : true) &&
            (this.state.leaveEntitlements ? !this.state.leaveEntitlements.loading : true) &&
            !this.state.invalidAttachment &&
            (!this.state.needToRecalculateBalance || this.state.forecastingError || this.state.selectedLeaveReason.LeaveType.Name === 'OtherLeave' || !this.state.selectedLeaveReason.LeaveType.IsDisplayBalance);
    }

    getAppData(model) {
        var attachments = null;

        if (this.state.attachment && this.state.attachment.content) {
            attachments = [{
                Attachment: {
                    Name: this.state.attachment.name,
                    Data: this.state.attachment.content,
                },
            }];
        }

        let isOverrideHours = true;
        if (this.state.workDaysAndHours && this.state.workDaysAndHours.DaysHours) {
            isOverrideHours = model.leaveHours !== this.state.workDaysAndHours.DaysHours.Hours;
        }

        let totalHours;
        if (this.state.IsHourApplication && this.state.startTime !== null && this.state.endTime !== null && 
            this.state.selectedLeaveReason?.LeaveType?.IsAllowHourApplication && this.state.startDate.isSame(this.state.endDate)) {
            totalHours = utils.hourDiffStartEndTimes(this.state.startTime, this.state.endTime); 
        } else if (this.state.tempHoursPerDay && model.leaveDays > 0) {
            totalHours = utils.formatNumber(parseFloat(model.leaveDays * this.state.tempHoursPerDay, 2, true));
        } else if (this.state.workDaysAndHours.DaysHours && this.state.workDaysAndHours.DaysHours !== 0) {
            totalHours = this.state.workDaysAndHours.DaysHours.Hours;
        } else if (this.props.person.leaveBalances && this.props.person.leaveBalances.balances && this.props.person.leaveBalances.balances.length > 0) {
            totalHours = utils.formatNumber(parseFloat(model.leaveDays * this.props.person.leaveBalances.balances[0].HoursPerDay, 2, true));
        } else {
            totalHours = 0;
        }        

        var data = {
            PersonId: this.props.person.Id,
            LeaveReason: this.state.leaveReasonMap[model.leaveReason],
            StartDate: this.convertDate(model.startDate),
            EndDate: this.convertDate(model.endDate),
            StartSession: this.state.startSession,
            EndSession: this.state.endSession,
            WorkingDays: this.state.leaveEnterHoursOrDays === 'days' ? model.leaveDays : (this.state.workDaysAndHours.DaysHours ? this.state.workDaysAndHours.DaysHours.Days : 0),
            TotalHours: this.state.leaveEnterHoursOrDays === 'days' ? totalHours : model.leaveHours,
            LeaveReasonId: this.state.leaveReasonMap[model.leaveReason].Id,
            Comments: model.comments,
            Attachments: attachments,
            IsOverrideHours: isOverrideHours,
            IsPayrollServiceOffline: this.state.forecastingError ? true : false,
            IsHourApplication: this.state.IsHourApplication,
            startTime: this.state.IsHourApplication ? this.state.startTime : null,
            endTime: this.state.IsHourApplication ? this.state.endTime : null,
        };
        
        if (this.state.isEditMode) {
            data.Id = this.props.application.Id;

            //NOTE: leave only allow one attachment per leave application at the moment
            if (data.Attachments) {
                data.AttachmentInfos = null; //clear attachmentInfos to delete original attachment when there is a new attachment
            } else {
                data.AttachmentInfos = this.state.attachmentInfos; //keep original attachment if there is no new attachment
            }
        }

        return data;

    }

    submitValid(model) {

        const data = this.getAppData(model);
        if (this.state.isEditMode) {
            personActions.editSinglePersonLeave(this.props.person.Id, data);
        } else {
            personActions.addSinglePersonLeave(this.props.person.Id, data);
        }

        AnalyticsManager.event(
            AnalyticsManager.constants.categories.APPLY_FOR_LEAVE, 
            AnalyticsManager.constants.actions.SUBMIT);

        return;
    }

    convertDate(dateString) {
        return moment.utc(dateString, constants.dates.formats.MINIMAL);
    }

    calculateLeaveDaysHours(event) {

        AnalyticsManager.event(
            AnalyticsManager.constants.categories.APPLY_FOR_LEAVE,
            AnalyticsManager.constants.actions.TEXT_FIELD,
            AnalyticsManager.constants.labels.LEAVE_HOURS);

        const workDaysandHoursClone = _.extend({}, this.state.workDaysAndHours);
        
        if (workDaysandHoursClone.DaysHours) {
            if (this.state.leaveEnterHoursOrDays === 'days') {
                workDaysandHoursClone.DaysHours.Days = event.currentTarget.value;
            } else {
                workDaysandHoursClone.DaysHours.Hours = event.currentTarget.value;
            }           
            
            if (this.state.tempHoursPerDay) {
                if (this.state.leaveEnterHoursOrDays === 'days') { 
                    workDaysandHoursClone.DaysHours.Hours = utils.formatNumber(parseFloat(workDaysandHoursClone.DaysHours.Days) * this.state.tempHoursPerDay, 2, true);
                } else {
                    workDaysandHoursClone.DaysHours.Days = utils.formatNumber(parseFloat(workDaysandHoursClone.DaysHours.Hours) / this.state.tempHoursPerDay, 2, true);
                }
            } else if (this.state.leaveEnterHoursOrDays === 'days') {
                // for EasyPay which has empty WorkHours, then try to get the hours per day from one of leave balances 
                if (this.props.person.leaveBalances && this.props.person.leaveBalances.balances && this.props.person.leaveBalances.balances.length > 0 
                    && this.props.person.leaveBalances.balances[0].HoursPerDay) {
                    workDaysandHoursClone.DaysHours.Hours = utils.formatNumber(parseFloat(workDaysandHoursClone.DaysHours.Days) 
                    * this.props.person.leaveBalances.balances[0].HoursPerDay, 2, true);
                }
            }

            this.setState({
                isInsufficientBalance: this.isInsufficientBalance(event.currentTarget.value),
                workDaysAndHours: workDaysandHoursClone,
            });
        }
    }

    onLeaveHoursChange = () => {
        this.setState({
            needToRecalculateBalance: true,
        });
    }

    onLeaveDaysChange = () => {
        this.setState({
            needToRecalculateBalance: true,
        });
    }

    isInsufficientBalance() {

        var isInsufficientBalance = this.state.leaveEntitlements &&
           this.state.leaveEntitlements.leaveEntitlements &&
           !this.state.leaveEntitlements.leaveEntitlements[0].IsValid;

        AnalyticsManager.event(
            AnalyticsManager.constants.categories.APPLY_FOR_LEAVE, 
            AnalyticsManager.constants.actions.AUTO,
            AnalyticsManager.constants.labels.FORECAST_BALANCE,
            isInsufficientBalance ? 0 : 1,
            true);

        return isInsufficientBalance;
    }

    getWorkDaysHours(startDate, endDate, startSession, endSession) {
        if (this.state.forecastingError) {
            //this.defaultBusinessDayCount(startDate, endDate);
            return;
        }
        
        const startDateToSend = startDate.format(constants.dates.formats.SERVER_POST_FORMAT);
        const endDateToSend = endDate.format(constants.dates.formats.SERVER_POST_FORMAT);

        const searchParams = {
            startDate: startDateToSend,
            endDate: endDateToSend,
            startSession,
            endSession,
        };

        if (_.isEqual(searchParams, this.state.lastSearchParams))
            return;
            
        personActions.getSinglePersonWorkDaysHours(this.props.person.Id,
            startDateToSend,
            endDateToSend,
            startSession,
            endSession
        );

        this.setState({
            lastSearchParams: searchParams,
        });
    }

    // check if end date or leave reason change
    getLeaveEntitlements(leaveReason = this.state.selectedLeaveReason, useOriginalApplication = false) {

        if (this.state.forecastingError) {
            return;
        }

        this.setState({
            needToRecalculateBalance: false,
        });

        //somehow need to get the leave reason

        const model = this.refs.form.getCurrentValues();
        model.leaveReason = leaveReason.Id;

        let leaveApp = this.props.application;
        if (!useOriginalApplication) {
            leaveApp = this.getAppData(model);
        }

        personActions.getSinglePersonLeaveBalanceValidation(
            this.props.person.Id,
            leaveApp
        );
    }

    refreshWorkDayHours() {
        if (this.state.showHalfDaySessions && (this.state.StartSession === null || this.state.endSession === null))
            return;

        this.getWorkDaysHours(this.state.startDate, this.state.endDate, this.state.startSession, this.state.endSession);   
    }

    checkDates(dateInput) {
        if (dateInput.props.name === 'startDate') {

            AnalyticsManager.event(
                AnalyticsManager.constants.categories.APPLY_FOR_LEAVE, 
                AnalyticsManager.constants.actions.DATE_PICKER,
                AnalyticsManager.constants.labels.START_DATE);

            if (this.refs.startDate.state.currentDate > this.refs.endDate.state.currentDate) {
                this.setState({
                    startDate: this.refs.startDate.state.currentDate,
                    endDate: this.refs.startDate.state.currentDate,
                }, this.refreshWorkDayHours);
            } else {
                if (this.state.IsHourApplication && this.refs.startDate.state.currentDate < this.refs.endDate.state.currentDate) {
                    this.setState({
                        startDate: this.refs.startDate.state.currentDate,
                        endDate: this.refs.startDate.state.currentDate,
                    }, this.refreshWorkDayHours);
                } else {
                    this.setState({
                        startDate: this.refs.startDate.state.currentDate,
                        endDate: this.refs.endDate.state.currentDate,
                    }, this.refreshWorkDayHours);
                }                
            }
        } else if (dateInput.props.name === 'endDate') {

            AnalyticsManager.event(
                AnalyticsManager.constants.categories.APPLY_FOR_LEAVE, 
                AnalyticsManager.constants.actions.DATE_PICKER,
                AnalyticsManager.constants.labels.END_DATE);

            if (this.refs.endDate.state.currentDate < this.refs.startDate.state.currentDate) {
                this.setState({
                    startDate: this.refs.endDate.state.currentDate,
                    endDate: this.refs.endDate.state.currentDate,
                }, this.refreshWorkDayHours);
            } else {
                if (this.state.IsHourApplication && this.refs.endDate.state.currentDate > this.refs.startDate.state.currentDate) {
                    this.setState({
                        startDate: this.refs.startDate.state.currentDate,
                        endDate: this.refs.startDate.state.currentDate,
                    }, this.refreshWorkDayHours);
                } else {
                    this.setState({
                        startDate: this.refs.startDate.state.currentDate,
                        endDate: this.refs.endDate.state.currentDate,
                    }, this.refreshWorkDayHours);
                }                
            }
        }

        if (this.state.selectedLeaveReason) {
            this.setState({
                needToRecalculateBalance: true,
            });
        }
    }

    
    handleApplyHalfDayCheckBoxChange() {
        if (!this.state.isHalfDay)
            this.setState({isHalfDay: !this.state.isHalfDay});
        else
            this.setState({isHalfDay: !this.state.isHalfDay, 
                startSession: constants.ENUMS.LEAVE_HALFDAY_SESSIONS.FIRST_HALF.VALUE,
                endSession: constants.ENUMS.LEAVE_HALFDAY_SESSIONS.SECOND_HALF.VALUE,
            }, this.refreshWorkDayHours);        
    }

    handleStartSessionSelect(select, selectedSession) {     
        if (this.state.startDate.isSame(this.state.endDate) && selectedSession > this.state.endSession) {
            this.setState({
                startSession: selectedSession,
                endSession: selectedSession,
            }, this.refreshWorkDayHours);
        } else {
            this.setState({
                startSession: selectedSession,
            }, this.refreshWorkDayHours);
        }
    } 
    
    handleEndSessionSelect(select, selectedSession) {     
        if (this.state.startDate.isSame(this.state.endDate) && this.state.startSession > selectedSession) {
            this.setState({
                startSession: selectedSession,
                endSession: selectedSession,
            }, this.refreshWorkDayHours);
        } else {
            this.setState({
                endSession: selectedSession,
            }, this.refreshWorkDayHours);
        }
    }

    onOverlappedLeaveChange(value) {
        this.setState({
            hasOverlappedLeave : value,
        });
    }

    handleLeaveReasonSelect(el, id) {

        const selectedLeaveReason = _.find(this.state.leaveReasons, function (reason) {
            return parseInt(reason.Id) === parseInt(id);
        });

        const isOtherLeaveType = selectedLeaveReason.LeaveType.Name === 'OtherLeave';

        if (!isOtherLeaveType && selectedLeaveReason.LeaveType.IsDisplayBalance) {
            let needToRecalculateBalance = false;

            if (this.state.autoCalculateBalances) {
                this.getLeaveEntitlements(selectedLeaveReason);
            } else {
                needToRecalculateBalance = true;
            }

            this.setState({needToRecalculateBalance});
        } 

        if (this.state.selectedLeaveReason?.LeaveType?.IsAllowHourApplication !== undefined && 
            this.state.selectedLeaveReason?.LeaveType?.IsAllowHourApplication !== null &&
            !this.state.selectedLeaveReason?.LeaveType?.IsAllowHourApplication) {
            setTimeout(() => {
                this.setState({
                    IsHourApplication: false,
                });
            }, 0);
            
        }

        AnalyticsManager.event(
            AnalyticsManager.constants.categories.APPLY_FOR_LEAVE, 
            AnalyticsManager.constants.actions.DROP_DOWN,
            AnalyticsManager.constants.labels.LEAVE_REASON);


        this.setState({
            selectedLeaveReason,
            canContinue: isOtherLeaveType ? true : selectedLeaveReason.LeaveType.IsAllowInsufficientBalance,
        });
    }

    updateAttachment(updates) {

        AnalyticsManager.event(
            AnalyticsManager.constants.categories.APPLY_FOR_LEAVE, 
            AnalyticsManager.constants.actions.ATTACHMENT);

        this.setState(updates);
    }

    handleComments(event) {

        if (event.currentTarget.value.length > 0) {
            AnalyticsManager.event(
                AnalyticsManager.constants.categories.APPLY_FOR_LEAVE, 
                AnalyticsManager.constants.actions.TEXT_AREA,
                AnalyticsManager.constants.labels.COMMENTS);
        }
       
    }

    onCalculateBalanceClick() {
        this.getLeaveEntitlements();
    }

    handleApplyHourCheckBoxChange(checked) {
        this.setState({
            IsHourApplication: checked,
        });
        // Validate and set start date and end date to same date
        if (this.refs.startDate.state.currentDate !== this.refs.endDate.state.currentDate) {
            this.setState({
                startDate: this.refs.startDate.state.currentDate,
                endDate: this.refs.startDate.state.currentDate,
            }, this.refreshWorkDayHours);
        }
    }

    onLeaveTimesChange = (timeInput, currentValue) => {
        if (currentValue !== undefined && currentValue !== null) {
            if (timeInput.props.name === 'startTime') {  
                this.setState({
                    startTime: currentValue,
                });
            } else if (timeInput.props.name === 'endTime') {                
                this.setState({
                    endTime: currentValue,
                });                
            }
        }
    }

    render() {
        if (!this.props.person) {
            return null;
        }
        
        var leaveReasonOptions = {};

        _.each(this.state.leaveReasons, function (reason) {
            leaveReasonOptions[reason.Id] = reason.Name;
        });

        const halfDaySessions = { 1 : constants.ENUMS.LEAVE_HALFDAY_SESSIONS.FIRST_HALF.LABEL, 2 : constants.ENUMS.LEAVE_HALFDAY_SESSIONS.SECOND_HALF.LABEL};
        
        var values = null;
        var app = this.props.application;

        var startDate = this.state.startDate;
        var endDate = this.state.endDate;
        var comments;

        var startTime = this.state.startTime;
        var endTime = this.state.endTime;

        if (app) {        
            comments = app.Comments;
            values = {
                leaveHours: this.state.workDaysAndHours.DaysHours && this.state.workDaysAndHours.DaysHours.Hours ? this.state.workDaysAndHours.DaysHours.Hours : app.TotalHours,
                leaveDays: this.state.workDaysAndHours.DaysHours && this.state.workDaysAndHours.DaysHours.Days ? this.state.workDaysAndHours.DaysHours.Days : app.WorkingDays,
                leaveReason: app.LeaveReason.Id,
            };
        }

        let leaveHourValue;        

        if (values) {
            leaveHourValue = values.leaveHours;
        } else if (this.state.workDaysAndHours.DaysHours) {
            leaveHourValue = this.state.workDaysAndHours.DaysHours.Hours;
        }
                                                          
        leaveHourValue = (leaveHourValue !== undefined && this.state.leaveEnterHoursOrDays === 'days') ? "({0} Hour{1})".format(leaveHourValue, leaveHourValue === 1 ? "" : "s") : leaveHourValue;
        
        let leaveDaysValue = (this.state.leaveEnterHoursOrDays === 'days') ? this.state.workDaysAndHours.DaysHours?.Days : 'n/a';
        if (values) {
            leaveDaysValue = values.leaveDays;
        } else if (this.state.workDaysAndHours.DaysHours && typeof(this.state.workDaysAndHours.DaysHours.Days) === "number") {
            leaveDaysValue = this.state.workDaysAndHours.DaysHours.Days;
        }

        leaveDaysValue = (this.state.leaveEnterHoursOrDays === 'days') ? leaveDaysValue : "({0} Day{1})".format(leaveDaysValue, leaveDaysValue === 1 ? "" : "s");        
        
        // eslint-disable-next-line no-unused-vars
        let maxHoursApplied = false;
        if (this.state.IsHourApplication && this.state.startTime !== null && this.state.endTime !== null) {
            const hourDiff = utils.hourDiffStartEndTimes(this.state.startTime, this.state.endTime);
            
            if (hourDiff > 0 && this.state.tempHoursPerDay > 0) {
                leaveDaysValue = Math.round((hourDiff / this.state.tempHoursPerDay) * 100) / 100;
                if (leaveDaysValue > 1) {
                    maxHoursApplied = true;
                }
            }
        }

        const popover = (
            <Popover content={(
                <PopoverContent heading="Apply half day?">
                    <PopoverContentSection>
                        Tick on "Apply half day" if you wish to apply: <br />
                        a. Half day leave (1st Half or 2nd Half) <br />
                        b. Leave which contains 0.5 day (1.5, 2.5, and etc)                   
                    </PopoverContentSection>
                </PopoverContent>
            )}
            >
                <span> Apply half day? <PopoverIcon /></span>
            </Popover>
        );

        return (
            <Formsy ref="form" onValidSubmit={this.submitValid} autoComplete="off" id="leave-apply">
                <ModalHeader>Apply for Leave</ModalHeader>
                <ModalBody>
                    <ConditionalDisplay test={this.state.forecastingError ? true : false} className="offline-msg">
                        <StatusBar
                            content="Payroll service is temporarily offline. Please enter leave hours manually."
                            warning
                        />
                    </ConditionalDisplay>

                    <div className="g--half separator">
                        <Fieldset className="empty">

                            <Group>
                                <div className="clear">
                                    <div className="g--half">
                                        <DateInput
                                            value={startDate}
                                            name="startDate"
                                            label="Start date"
                                            ref="startDate"
                                            onChangeCallback={this.checkDates}
                                            required
                                        />
                                    </div>
                                    <div className="g--half g--last">
                                        <DateInput
                                            value={endDate}
                                            name="endDate"
                                            label="End date"
                                            ref="endDate"
                                            onChangeCallback={this.checkDates}
                                            validations={{
                                                isAfterDate: "startDate",
                                            }}
                                            validationErrors={{
                                                isAfterDate: "End date must be after start date. ",
                                            }}
                                            required
                                        />
                                    </div>
                                </div>

                                {this.state.IsHourApplication && this.state.selectedLeaveReason?.LeaveType?.IsAllowHourApplication ?
                                    (
                                        <div className="clear">
                                            <div className="g--half">
                                                <TimeInput
                                                    name={"startTime"}
                                                    label="Start Time"
                                                    ref="startTime"   
                                                    display24HrFormat                                                 
                                                    roundToMinutes={15}
                                                    value={startTime ? startTime : ''}
                                                    onBlurCallback={this.onLeaveTimesChange.bind(this)}
                                                    disabled={this.state.workDaysAndHours.loading}
                                                    required
                                                />
                                            </div>
                                            <div className="g--half g--last">
                                                <TimeInput
                                                    name={"endTime"}
                                                    label="End Time"
                                                    ref="endTime"
                                                    display24HrFormat
                                                    roundToMinutes={15}
                                                    value={endTime ? endTime : ''}
                                                    onBlurCallback={this.onLeaveTimesChange.bind(this)}
                                                    extraValidations={[
                                                        [{isAfterTime: ["startTime", "End time must be after start time. "]}],
                                                    ]}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    ) : null
                                }

                                {this.state.isHalfDay ?
                                    (
                                        <div className="clear">
                                            <div className="g--half">
                                                <Select
                                                    value={this.state.startSession}
                                                    name="startSession"
                                                    options={halfDaySessions}                                         
                                                    ref="startSession"
                                                    onChangeCallback={this.handleStartSessionSelect}
                                                    disabled={this.state.workDaysAndHours.loading}
                                                    noLabel                                  
                                                    required                                            
                                                />
                                            </div>
                                            <div className="g--half g--last">
                                                <Select
                                                    value={this.state.endSession}
                                                    name="endSession"
                                                    options={halfDaySessions}                                        
                                                    ref="endSession"
                                                    onChangeCallback={this.handleEndSessionSelect} 
                                                    disabled={this.state.workDaysAndHours.loading}
                                                    noLabel                                      
                                                    required                                            
                                                />
                                            </div>
                                        </div>
                                    ) : null
                                }
                                
                                <div>
                                    <Select
                                        value={values ? values.leaveReason : undefined}
                                        name="leaveReason"
                                        options={leaveReasonOptions}
                                        label="Reason"
                                        onChangeCallback={this.handleLeaveReasonSelect}
                                        ref="leaveReason"
                                        sortByValue
                                        required
                                        disabled={this.state.workDaysAndHours.loading}
                                    />
                                </div>

                                {this.state.selectedLeaveReason?.LeaveType?.IsAllowHourApplication ? (
                                    <> 
                                        <CheckBox
                                            name="applyHour"
                                            label="Hour Application"
                                            checked={this.state.IsHourApplication}                                               
                                            disabled={this.state.workDaysAndHours.loading || this.state.isHalfDay}
                                            onChange={this.handleApplyHourCheckBoxChange}
                                        />
                                    </>
                                ) : null }
                                

                                {this.state.showHalfDaySessions && !this.state.IsHourApplication ?
                                    (       
                                        <div className="clear">
                                            <CheckBox                                                
                                                name="cbHalfDayLeave" 
                                                label={popover}
                                                onChange={this.handleApplyHalfDayCheckBoxChange}  
                                                checked={this.state.isHalfDay}
                                                disabled={this.state.workDaysAndHours.loading}
                                            />
                                        </div>
                                    )                                         
                                    : null
                                } 
                               
                                <div className="clear">
                                    {this.state.leaveEnterHoursOrDays === 'days' ? 
                                        (
                                            <TextInputWithSign
                                                value={leaveDaysValue}
                                                name="leaveDays"
                                                loading={this.state.workDaysAndHours.loading}
                                                label={"Leave days" + (this.state.workDaysAndHours.loading ? "..." : "")}
                                                ref="leaveDays"
                                                validations={{
                                                    isNumeric: true,
                                                    hasWorkHours(values, value) {
                                                        return typeof(value) === "number" ? value !== 0 : true;
                                                    },
                                                    greaterThanZero: true,
                                                    matchRegexp: constants.regex.CURRENCY,
                                                    hasMaxHoursApplied() {
                                                        return !maxHoursApplied;
                                                    },
                                                }}
                                                validationErrors={{
                                                    isNumeric: constants.error.FORMS.IS_NUMERIC,
                                                    hasWorkHours: 'You have no work days in this period. ',
                                                    greaterThanZero: 'Negative leave days cannot be entered. ',
                                                    matchRegexp: "Maximum of 2 decimal places. ",
                                                    hasMaxHoursApplied: "Time applied exceeds hours per day. ",
                                                }}
                                                onBlurCallback={this.calculateLeaveDaysHours}
                                                onChangeCallback={this.onLeaveDaysChange}
                                                disabled={this.state.workDaysAndHours.loading}
                                                signContent={this.state.workDaysAndHours.loading ? null : leaveDaysValue}
                                                readOnly={this.state.showHalfDaySessions || this.state.IsHourApplication}
                                                required
                                            />                                        
                                        ) : 
                                        (
                                            <TextInputWithSign
                                                value={leaveHourValue}
                                                name="leaveHours"
                                                loading={this.state.workDaysAndHours.loading}
                                                label={"Leave hours" + (this.state.workDaysAndHours.loading ? "..." : "")}
                                                ref="leaveHours"
                                                validations={{
                                                    isNumeric: true,
                                                    hasWorkHours(values, value) {
                                                        return typeof(value) === "number" ? value !== 0 : true;
                                                    },
                                                    greaterThanZero: true,
                                                    matchRegexp: constants.regex.CURRENCY,
                                                }}
                                                validationErrors={{
                                                    isNumeric: constants.error.FORMS.IS_NUMERIC,
                                                    hasWorkHours: 'You have no work hours in this period. ',
                                                    greaterThanZero: 'Negative leave hours cannot be entered. ',
                                                    matchRegexp: "Maximum of 2 decimal places. ",
                                                }}
                                                onBlurCallback={this.calculateLeaveDaysHours}
                                                onChangeCallback={this.onLeaveHoursChange}
                                                disabled={this.state.workDaysAndHours.loading}
                                                signContent={this.state.workDaysAndHours.loading ? null : leaveDaysValue}
                                                append
                                                required
                                            />
                                        )
                                    }
                                </div>
                            </Group>                            

                            <LeaveApplyAttachments
                                isEditMode={this.state.isEditMode}
                                application={this.props.application}
                                onUpdateCallback={this.updateAttachment}
                                name="leaveAttachment"
                            />

                            <Group>
                                <TextArea
                                    name="comments"
                                    label="Comments"
                                    ref="comments"
                                    value={comments}
                                    validations="maxLength:2000"
                                    validationError="You've reached the maximum comment length"
                                    maxLength="2000"
                                    onBlurCallback={this.handleComments.bind(this)}
                                />
                            </Group>
                        </Fieldset>
                    </div>

                    <div className="g--half g--last">
                        <Fieldset className="empty">
                            <Group>
                                <LeaveApplyEntitlements
                                    selectedLeaveReason={this.state.selectedLeaveReason}
                                    endDate={endDate}
                                    leaveEntitlements={this.state.leaveEntitlements}
                                    canContinue={this.state.canContinue}
                                    forecastingError={this.state.forecastingError}
                                    isInsufficientBalance={this.state.isInsufficientBalance}
                                    leaveHourValue={leaveHourValue}
                                    previousLeaveHours={this.state.previousLeaveHours}
                                    needToRecalculateBalance={this.state.needToRecalculateBalance}
                                    onCalculateBalanceClick={this.onCalculateBalanceClick}
                                    workDaysAndHoursLoading={this.state.workDaysAndHours.loading}
                                />
                            </Group>
                        </Fieldset>

                        <LeaveApplyOverlappedLeave
                            startDate={startDate}
                            endDate={endDate}
                            startSession={this.state.startSession}
                            endSession={this.state.endSession}
                            person={this.props.person}
                            leaveApplications={this.state.leaveApplications}
                            forecastingError={this.state.forecastingError}
                            application={this.props.application}
                            showError={this.state.showHalfDaySessions} 
                            onOverlappedLeaveChange={this.onOverlappedLeaveChange} 
                            IsHourApplication={this.state.IsHourApplication} 
                            startTime={this.state.startTime}   
                            endTime={this.state.endTime}                  
                        />
                    </div>
                </ModalBody>

                <ModalFooter>
                    <div className="modal-footer">
                        <button id="button-apply-leave-apply" type="submit" className="button--primary" disabled={!this.shouldEnableButton(leaveDaysValue)} formNoValidate>Apply</button>
                    </div>
                </ModalFooter>
            </Formsy>
        );
    }
}

export default LeaveApply;
